import { render, staticRenderFns } from "./UserDashboardTabsPayments.vue?vue&type=template&id=47d23e89&scoped=true&"
import script from "./UserDashboardTabsPayments.vue?vue&type=script&lang=js&"
export * from "./UserDashboardTabsPayments.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardTabsPayments.vue?vue&type=style&index=0&id=47d23e89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d23e89",
  null
  
)

export default component.exports